import { render, staticRenderFns } from "./SelectProduct.vue?vue&type=template&id=6ee5a788&scoped=true"
import script from "./SelectProduct.vue?vue&type=script&lang=js"
export * from "./SelectProduct.vue?vue&type=script&lang=js"
import style0 from "./SelectProduct.vue?vue&type=style&index=0&id=6ee5a788&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee5a788",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ee5a788')) {
      api.createRecord('6ee5a788', component.options)
    } else {
      api.reload('6ee5a788', component.options)
    }
    module.hot.accept("./SelectProduct.vue?vue&type=template&id=6ee5a788&scoped=true", function () {
      api.rerender('6ee5a788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/publishProduct/children/SelectProduct.vue"
export default component.exports